/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/distributorList.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_DISTRIBUTOR_LIST } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { StorageModule } from "@vlinder-web/storage-module-react";

const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IDistributorListMethods extends IPluginMethodMap {
  getDistributorList(args: any): Promise<any>;
}

export class DistributorListService implements IAgentPlugin {
  readonly methods: IDistributorListMethods;

  constructor() {
    this.methods = {
      getDistributorList: this.getDistributorList.bind(this),
    };
  }

  async getDistributorList(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      // return {...config}
      if (client) {
        let role = storageService.get("bandConfig", "local")?.roles;
        role =
          role &&
          Array.isArray(role) &&
          role.length > 0 &&
          role.filter((r: any) => r.role === "distributor");
        const res = await client.query({
          query: GET_DISTRIBUTOR_LIST,
          variables: {
            options: {
              skip: args?.offset ?? 0,
              limit: args?.size ?? 10,
            },
            filters: {
              ...args?.criteria,
              role__in:
                role && Array.isArray(role) && role.length === 1
                  ? role[0]?.uuid
                  : null,
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          console.log(`table data`, res);
          let _totalPages = res?.data?.getUsersWithBoxes?.count
            ? parseInt(res?.data?.getUsersWithBoxes?.count) / 10
            : 1;
          let _currentPage =
            res?.data?.getUsersWithBoxes?.skip /
              res?.data?.getUsersWithBoxes?.limit +
            1;
          let _rowData = this.formatPackerTable(
            res?.data?.getUsersWithBoxes?.content
          );
          console.log(`row data`, _rowData);
          return {
            ...config,
            ultUsers: _rowData,
            isEmpty: res?.data?.getUsersWithBoxes?.content?.length <= 0,
            // studentGroup: holderGroups,
            activePage: _currentPage,
            pageSize: res?.data?.getUsersWithBoxes?.limit,
            totalCount: res?.data?.getUsersWithBoxes?.count,
            totalPages: _totalPages,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private formatPackerTable(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any) => {
        return {
          id: item?.id,
          vuid: item?.vuid,
          // status: item?.status,
          status: this.getFormattedStatus(item?.accountStatus, item?.suspended),
          name: `${item?.firstName} ${item?.lastName}`,
          email: item?.email,
          dateCreated: this.formatCreatedDate(item?.createdAt),
          group: item?.group,
          image: item?.img,
          verified: item?.emailVerified,
        };
      });

    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    const metaData = storageService.get("bandConfig", "local")?.metaData;
    if (date && metaData) {
      let _date = `${moment.tz(date, metaData?.tmz).format("LLL")} ${
        metaData?.abbrevation
      }`;
      return _date;
    }
  }

  private getFormattedStatus(status: string, suspended: boolean) {
    if (suspended) {
      return "suspended";
    } else {
      switch (status) {
        case "USER_ADDED":
          return "created";
        case "USER_INVITED":
          return "invited";
        case "USER_VERIFIED":
          return "verified";
        case "USER_ACC_CREATED":
          return "active";
        case "SUSPENDED":
          return "suspended";
        default:
          return "-";
      }
    }
  }
}
